/* hod-drawer-lazy.js — header diet (3.9.3 K.5) + 10/7 flicker fix. Owner note: header/menu files belong to the
   Menu session; this loader is deliberately separate so hod-menu.js stays untouched.
   The full mobile drawer (snippets/hod-mobile-menu) is no longer in the page. #mobile-menu ships the SAME snippet in
   skeleton mode (header + department rows, inert) inside [data-hod-drawer-src]; this script fetches the full drawer
   from the header section through the Section Rendering API (/pages/hod-menu-drawer?section_id=…, where
   sections/header.liquid renders only the drawer inner), swaps it in and boots it with window.HODMenu.init().
   10/7: the fetch starts as soon as this script runs on a phone/tablet viewport (not after window load), the drawer is
   remembered in sessionStorage for 10 minutes so later pages of the visit never fetch, and the swap happens on the
   first hamburger tap at the latest. Desktop never fetches. If the fetch fails the skeleton rows become plain links. */
(function () {
  'use strict';
  var mm = document.getElementById('mobile-menu');
  var slot = mm && mm.querySelector('[data-hod-drawer-src]');
  if (!mm || !slot) return;
  var src = slot.getAttribute('data-hod-drawer-src');
  var KEY = 'hodDrawer:' + src, TTL = 10 * 60 * 1000;
  var pending = null, done = false, node = null;
  var narrow = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  var conn = navigator.connection || {};
  var frugal = !!(conn.saveData || /2g/.test(conn.effectiveType || '') || (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches));

  function drawerOpen() { return mm.getAttribute('aria-hidden') === 'false'; }
  function status(t) { var st = slot.querySelector('.hod-mm-lazy__status'); if (st) st.textContent = t; }
  function whenIdle(fn) { if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 400); }

  function fail(err) {
    pending = null;
    slot.removeAttribute('aria-busy');
    var sk = slot.querySelector('[data-hm-skeleton]');
    if (sk) {
      sk.classList.remove('hod-mm--skel');
      var inert = sk.querySelectorAll('[tabindex="-1"]');
      for (var i = 0; i < inert.length; i++) inert[i].removeAttribute('tabindex');
    }
    status('Menu could not be fully loaded. The department links still work.');
    /* visible in the console on purpose: if the hidden page /pages/hod-menu-drawer is ever deleted or unpublished,
       every phone gets the plain department list instead of the drawer */
    try { console.warn('hod-drawer-lazy: mobile drawer unavailable, showing the plain department list', err && err.message ? err.message : err); } catch (e) {}
  }
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root = doc.querySelector('[data-hm-mobile]');
    if (!root) throw new Error('no [data-hm-mobile] in the response (is the page /pages/hod-menu-drawer still published?)');
    return document.importNode(root, true);
  }
  /* the skeleton was rendered with THIS page's cart count; a cached drawer may be minutes old */
  function syncCart(n) {
    var a = slot.querySelector('.hod-mm__count'), b = n.querySelector('.hod-mm__count');
    if (a && b) { b.textContent = a.textContent; b.setAttribute('data-count', a.getAttribute('data-count') || ''); }
    var la = slot.querySelector('.hod-mm__cart'), lb = n.querySelector('.hod-mm__cart');
    if (la && lb && la.getAttribute('aria-label')) lb.setAttribute('aria-label', la.getAttribute('aria-label'));
  }
  /* 10/7 (Stas: department panes "flicker"): a pane's tile images only start loading when it opens (hod-menu.js wakes
     the open group's lazy images), so the pane paints empty and fills 0.1–0.6 s later. Now the images fade in instead
     of popping, the first tile group of the first WARM_DEPTS departments is fetched as soon as the drawer opens, and a
     finger landing on a department row fetches that department's first group at high priority before the tap lands.
     Skipped under Save-Data. */
  var WARM_DEPTS = 4, warmed = false;
  function fadeReady(root) {
    var imgs = root.querySelectorAll('[data-hm-detail] img');
    for (var i = 0; i < imgs.length; i++) (function (img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('hod-mm-img--in'); return; }
      var on = function () { img.classList.add('hod-mm-img--in'); };
      img.addEventListener('load', on, { once: true });
      img.addEventListener('error', on, { once: true });
    })(imgs[i]);
  }
  function groupImgs(detail) {
    var grp = detail.querySelector('[data-hm-mtiles].is-on') || detail.querySelector('[data-hm-mtiles="0"]') || detail;
    var imgs = grp.querySelectorAll('img[loading="lazy"]');
    return imgs.length > 24 ? Array.prototype.slice.call(imgs, 0, 24) : imgs;
  }
  function warmDetail(detail, high) {
    var imgs = groupImgs(detail);
    for (var i = 0; i < imgs.length; i++) { if (high) { try { imgs[i].fetchPriority = 'high'; } catch (e) {} } imgs[i].loading = 'eager'; }
  }
  function warmPanes() {
    if (warmed || !node || !done || frugal) return;
    warmed = true;
    var details = node.querySelectorAll('[data-hm-detail]'), i = 0;
    (function step() { if (i >= details.length || i >= WARM_DEPTS) return; warmDetail(details[i++], false); whenIdle(step); })();
  }
  document.addEventListener('touchstart', function (e) {
    var row = e.target && e.target.closest ? e.target.closest('#mobile-menu [data-hm-open]') : null;
    if (!row || !node || frugal) return;
    var d = node.querySelector('[data-hm-detail="' + row.getAttribute('data-hm-open') + '"]');
    if (d) warmDetail(d, true);
  }, { passive: true });
  function place() {
    if (done || !node) return;
    syncCart(node);
    slot.replaceWith(node);
    done = true;
    fadeReady(node);
    if (window.HODMenu && typeof window.HODMenu.init === 'function') window.HODMenu.init(node);
    document.dispatchEvent(new CustomEvent('hod:drawer:ready', { detail: { root: node } }));
    if (drawerOpen()) whenIdle(warmPanes);
  }
  function ready(n) { node = n; if (drawerOpen()) place(); else whenIdle(place); }
  function fromCache() {
    try {
      var raw = sessionStorage.getItem(KEY); if (!raw) return false;
      var c = JSON.parse(raw);
      if (!c || !c.html || Date.now() - c.t > TTL) { sessionStorage.removeItem(KEY); return false; }
      ready(parse(c.html)); return true;
    } catch (e) { return false; }
  }
  function store(html) {
    try { var root = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hm-mobile]'); if (root) sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), html: root.outerHTML })); } catch (e) {}
  }
  function load() {
    if (done || node) return Promise.resolve();
    if (pending) return pending;
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : null;
    pending = fetch(src, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { var n = parse(html); store(html); ready(n); })
      .catch(fail)
      .then(function () { if (timer) clearTimeout(timer); });
    return pending;
  }
  /* first tap: swap now if the drawer is ready, otherwise make sure the fetch is running (capture phase, before
     theme.js toggles the drawer open) */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-action="toggle-menu"]') : null;
    if (!t || t.getAttribute('aria-controls') !== 'mobile-menu') return;
    if (node) { place(); whenIdle(warmPanes); } else load();
  }, true);

  function start() {
    if (narrow && !narrow.matches) return;        /* desktop never needs the drawer */
    if (fromCache()) return;
    if (!frugal) load();                           /* Save-Data: wait for the first tap */
  }
  start();                                         /* deferred script: the DOM is parsed, fetch right away */
  if (narrow) {
    var onChange = function (m) { if (m.matches) start(); };
    if (typeof narrow.addEventListener === 'function') narrow.addEventListener('change', onChange);
    else if (typeof narrow.addListener === 'function') narrow.addListener(onChange);
  }
  window.hodDrawerLazy = { load: load, place: place };
})();
